import { render } from "./IconWallpaper.vue?vue&type=template&id=ae1f793e"
import script from "./IconWallpaper.vue?vue&type=script&lang=js"
export * from "./IconWallpaper.vue?vue&type=script&lang=js"

import exportComponent from "../../../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__